import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentMethodState } from '../../codegen/vehicles';
import { useAppDispatch, useAppSelector } from '../hooks';
import { useLoadedVehicles } from './useVehicles';

type PaymentMethodUpdate = {
  vehicleId: string;
  paymentMethodId: string;
  paymentMethodState: PaymentMethodState;
};

export type PaymentMethodUpdateState = {
  update?: PaymentMethodUpdate;
};

const initialState: PaymentMethodUpdateState = {
  update: undefined,
};

export const paymentMethodUpdateSlice = createSlice({
  name: 'paymentMethodUpdate',
  initialState,
  reducers: {
    setPaymentMethodUpdate: (
      state,
      action: PayloadAction<PaymentMethodUpdate | undefined>,
    ) => {
      state.update = action.payload;
    },
  },
});

export const usePaymentMethodUpdateState = () => {
  const dispatch = useAppDispatch();
  const { updatePaymentMethod } = useLoadedVehicles();

  const paymentMethodUpdate = useAppSelector(
    (state) => state.paymentMethodUpdate.update,
  );

  const setPaymentMethodUpdate = (update?: PaymentMethodUpdate) => {
    if (update) {
      updatePaymentMethod(update.vehicleId, update.paymentMethodId, (pm) => {
        pm.state = update.paymentMethodState;
        return pm;
      });
    }

    dispatch(paymentMethodUpdateSlice.actions.setPaymentMethodUpdate(update));
  };

  return {
    paymentMethodUpdate,
    setPaymentMethodUpdate,
  };
};
